"use client";

import * as React from "react";

declare global {
  interface Window {
    google?: any;
  }
}

export default function GoogleMapsLoader({
  children,
}: {
  children: React.ReactNode;
}) {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    if (!key) {
      console.error("❌ Missing REACT_APP_GOOGLE_MAPS_API_KEY");
      return;
    }

    // ήδη φορτωμένο
    if (window.google?.maps?.places) {
      setReady(true);
      return;
    }

    // αν υπάρχει script
    const existing = document.querySelector(
      'script[data-google-maps="1"]'
    ) as HTMLScriptElement | null;

    if (existing) {
      existing.addEventListener("load", () => setReady(true));
      return;
    }

    const script = document.createElement("script");
    script.src =
      `https://maps.googleapis.com/maps/api/js` +
      `?key=${encodeURIComponent(key)}` +
      `&libraries=places`;
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = "1";

    script.onload = () => {
      if (window.google?.maps?.places) {
        setReady(true);
      } else {
        console.error("❌ Google Maps loaded but places missing");
      }
    };

    script.onerror = () => {
      console.error("❌ Failed to load Google Maps script");
    };

    document.head.appendChild(script);
  }, [key]);

  if (!ready) {
    return null; // ⛔ ΜΗΝ render τίποτα πριν φορτώσει
  }

  return <>{children}</>;
}
